module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6797bfe614ccb22ae04e5aa618d7f483.png";